import { httpDelete, httpGet, httpPost, httpPut } from 'utils/httpRequest'

export const listExperts = async () => {
  const resp = await httpGet('admin/experts')
  return resp?.data ?? resp
}

export const createExpert = async (payload) => {
  const resp = await httpPost('admin/experts/create', payload)
  return resp
}

export const updateExpert = async (id, payload) => {
  const resp = await httpPut(`admin/experts/update/${id}`, payload)
  return resp
}

export const deleteExpert = async (id) => {
  const resp = await httpDelete(`admin/experts/delete/${id}`)
  return resp
}

export const getExpertDetail = async (id) => {
  const resp = await httpGet(`admin/experts/${id}`)
  return resp?.data ?? resp
}

export const getExpertByProgram = async (programId) => {
  const resp = await httpGet(`admin/experts/byProgram/${programId}`)
  return resp?.data ?? resp
}

export const getExpertByInnercise = async (innerciseId) => {
  const resp = await httpGet(`admin/experts/byInnercise/${innerciseId}`)
  return resp?.data ?? resp
}

export const setProgramExpert = async (programId, expertId) => {
  const payload = { programId, expertId: expertId || null }
  const resp = await httpPut(`admin/experts/setProgramExpert`, payload)
  return resp?.data ?? resp
}

export const setInnerciseExpert = async (innerciseId, expertId) => {
  const payload = { innerciseId, expertId: expertId || null }
  const resp = await httpPut(`admin/experts/setInnerciseExpert`, payload)
  return resp?.data ?? resp
}

export const toggleExpertStatus = async (id) => {
  // Since toggleStatus endpoint doesn't exist, we'll fetch the expert first
  // then update with the toggled status
  try {
    // Get current expert data
    const expertDetail = await getExpertDetail(id)
    const expert = expertDetail.expert || expertDetail.data?.expert || expertDetail
    
    // Toggle the status
    const newStatus = !expert.isActive
    
    // Update with all required fields
    const payload = {
      name: expert.name || '',
      description: expert.description || '',
      imageUrl: expert.imageUrl || null,
      imageResourceId: expert.imageResourceId || expert.image?.id || null,
      link: expert.link || '',
      socialHandles: expert.socialHandles || {},
      isActive: newStatus,
      sortOrder: expert.sortOrder ?? 0,
      programIds: expertDetail.programIds || expertDetail.data?.programIds || [],
      innerciseIds: expertDetail.innerciseIds || expertDetail.data?.innerciseIds || [],
    }
    
    const resp = await httpPut(`admin/experts/update/${id}`, payload)
    return resp?.data ?? resp
  } catch (error) {
    throw error
  }
}

